import { gql } from "@apollo/client";

const GET_OUTGOING_TRAINEESHIP_LISTING = gql`
  query Traineeships($page: Int!, $sortBy: String!, $optionalTrFilters: OptionalTRFilters) {
  traineeships(page: $page, sortBy: $sortBy, optionalTRFilters: $optionalTrFilters) {
    page
    nextLink
    traineeshipList {
      traineeshipID
      traineeship_id
      title
      field_tr_status
      field_tr_student_firstname
      field_tr_student_lastname
      field_tr_student_email
      sending_institution
      receiving_organization
      receiving_organization_country
      sending_institution_hei
      sending_institution_country
      sending_contact_person_firstname
      sending_contact_person_lastname
      field_of_education
      planned_period_start_date
      planned_period_end_date
      created
      changed
    }
  }
}`
;

export default GET_OUTGOING_TRAINEESHIP_LISTING;
